// eslint-disable-next-line import/prefer-default-export
export const resolveGtin = () => new Error('not implemented');
